const PublicReleaseView = () => {
  return (
    <div className="card">
      <h5>Public Release</h5>
      <div className="mt-2 space-y-4">
        <div className=" -mx-2">
          <table>
            <thead>
              <tr>
                <th>
                  <b className="text-orange-500">Jordan</b>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>
                  <label>Life style photos</label>
                </td>
                <td className="text-right">
                  <input type="checkbox" />
                </td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>
                  <label>Life style Videos</label>
                </td>
                <td className="text-right">
                  <input type="checkbox" />
                </td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>
                  <label>Email Announcement</label>
                </td>
                <td className="text-right">
                  <input type="checkbox" />
                </td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>
                  <label>Beauty shots</label>
                </td>
                <td className="text-right">
                  <input type="checkbox" />
                </td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>
                  <label>Amazon Content</label>
                </td>
                <td className="text-right">
                  <input type="checkbox" />
                </td>
              </tr>
              <tr className="border-y border-gray-100 dark:border-gray-700">
                <td>
                  <label>Product Description</label>
                </td>
                <td className="text-right">
                  <input type="checkbox" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PublicReleaseView;
